import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { NotificationEvent } from '../../models/events/notification-event.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class NotificationEventService {
  private service = "api/NotificationEvent"; //Controller Name
  public notificationEventList: NotificationEvent[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  GetNotificationEvents() {
    return this.http.get(`${this.service}/GetNotificationEvents`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  AddNotificationEvent(notificationEvent: NotificationEvent): void {
    this.http
      .post(`${this.service}`, notificationEvent, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/notification-event-list"]);
      });
  }
  UpdateNotificationEvent(notificationEvent: NotificationEvent): void {
    this.http
      .put(`${this.service}`, notificationEvent, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/notification-event-list"]);
      });
  }
  GetNotificationEventById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <NotificationEvent>response.json())
      .catch(this.errorHandler)
  }
  DeleteNotificationEvent(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/event/notification-event.service.ts